import { render, staticRenderFns } from "./NewContract.vue?vue&type=template&id=5b70aa37&scoped=true&lang=pug&"
import script from "./NewContract.vue?vue&type=script&lang=ts&"
export * from "./NewContract.vue?vue&type=script&lang=ts&"
import style0 from "./NewContract.vue?vue&type=style&index=0&id=5b70aa37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70aa37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VSelect,VTextField,VTextarea})
